import { t } from 'Locale';
import { isMagioEnv, isTMCZEnv } from 'Options';

export const BINGE_CHANNEL = 'urn:x-cast:com.player.binge';
export const SWITCH_CHANNEL = 'urn:x-cast:com.player.switch';
export const SPLASH_SCREEN_CHANNEL = 'urn:x-cast:com.player.splash.screen';
export const APP_STATE_CHANNEL = 'urn:x-cast:com.mobile.app.state';
export const VOLUME_CHANNEL = 'urn:x-cast:com.player.volume';
export const WARNING_CHANNEL = 'urn:x-cast:com.player.warning';
export const CONTINUE_ON_PHONE_CHANNEL = 'urn:x-cast:com.player.continue.on.phone';
export const CONTINUE_WATCHING_CHANNEL = 'urn:x-cast:com.player.continue.watching';

let BRAND: 'MAGIO' | 'MAGENTA' | 'DIGI' = 'MAGIO';

if (isTMCZEnv) {
    BRAND = 'MAGENTA';
} else if (isMagioEnv) {
    BRAND = 'MAGIO';
} else {
    BRAND = 'DIGI';
}
export const splashObject = {
    adText:
        t('SS.CHROMECAST.AD_SKIP.SEEKING_FORBIDDEN_ERROR_MSG') ??
        'Based on the request from FTV Prima, we are limiting the ability to fast-forward',
    loadingText:
        t('SS.CHROMECAST.CASTING_FROM_MOBILE_APP_TITLE') ?? 'Casting from Magio TV mobile app',
    waitingTitle: t('SS.CHROMECAST.OPEN_DEVICE_TO_REFRESH_DATA_HINT_TXT') ?? 'Hint:',
    waitingText:
        t('SS.CHROMECAST.OPEN_DEVICE_TO_CONTINUE_CASTING_TXT') ?? 'Open app to continue casting',
    refreshText:
        t('SS.CHROMECAST.OPEN_DEVICE_TO_REFRESH_DATA_TXT') ??
        'To update metadata of a programm open app',
    offlineText:
        t('SS.CHROMECAST.NO_CONNECTION_HINT_TXT') ??
        'The app on your mobile went offline. Please turn on Wi-Fi to reconnect to the TV',
    castingTitle: t('SS.CHROMECAST.CASTING_ACTIVE_TITLE') ?? 'Casting is still active',
    castingText:
        t('SS.CHROMECAST.CASTING_ACTIVE_DESCRIPTION') ??
        'Choose another program to continue casting',
    castingOr: t('SS.CHROMECAST.CASTING_ACTIVE_TEXT') ?? 'Or',
    castingButton: t('SS.CHROMECAST.CASTING_ACTIVE.CANCEL_BTN') ?? 'Cancel casting',
    brand: BRAND
} as const;

export const DEFAULT_MEDIA_STATE = {
    isSeekableForward: true,
    isPaused: false
} as const;

export enum MediaPlayerState {
    /** Player is in PLAY mode but not actively playing content. currentTime will not change. */
    BUFFERING = 'buffering',
    /** No media is loaded into the player. */
    IDLE = 'idle',
    /** The media is loading. */
    LOADING = 'loading',
    /** The media is not playing. */
    PAUSED = 'paused',
    /** The media is playing. */
    PLAYING = 'playing'
}
